export default __webpack_public_path__ + "static/media/image-study-board-2-w@3x.f87f1f1e.webp";